import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs, Typography, Box } from "@mui/material";
import { IoHomeOutline, IoChevronForwardOutline } from "react-icons/io5";
import "./Breadcrumb.scss";

const Breadcrumb = ({ items ,direction}) => {
    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
                padding: "16px",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#ECF4FA",
                direction: direction, 
                mb: 2,
            }}
            separator={
                <IoChevronForwardOutline
                    style={{
                        color: "#6B6B6B", // Separator icon color
                        fontSize: "22px", // Separator icon size
                    }}
                />
            }
        >
            {/* Home Icon Link */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Link
                    to="/"
                    style={{
                        textDecoration: "none",
                        color: "#12538B",
                        display: "flex",
                        alignItems: "center",
                    }}
                    className="breadcrumb-link"
                >
                    <IoHomeOutline
                        style={{
                            marginLeft: "5px",
                            color: "#6B6B6B",
                            fontSize: "22px",
                        }}
                    />
                </Link>
            </Box>

            {/* Dynamic Breadcrumb Items */}
            {items.map((item, index) =>
                item ? (
                    <Typography
                        key={index}
                        component={index === 0 ? Link : "span"} // Make the first item a link
                        to="#"
                        color={index === items.length - 1 ? "#12538B" : "#646464"} // Highlight the last item
                        sx={{
                            textDecoration: index === 0 ? "none" : "inherit", // Remove underline for links
                            fontWeight: index === items.length - 1 ? 700 : 400, // Bold the last item
                            fontSize: {
                                xs: "10px", // Small screen (xs)
                                sm: "12px", // Medium screen (sm)
                                md: "14px", // Medium and larger screen (md)
                                lg: "14px", // Large screen (lg)
                            },
                            "&:hover": {
                                color: index === items.length - 1 ? "#1E72B3" : "#646464", // Hover effect for links
                                cursor: index === 0 ? "pointer" : "default", // Pointer for the first item
                            },
                        }}
                    >
                        {item.title || item}
                    </Typography>
                ) : null
            )}
        </Breadcrumbs>
    );
};

export default Breadcrumb;
